import { updateSelectedCountries, } from "@Api/CountrySettings/countryGroup";
import Button from "@Components/Button";
import Card from "@Components/Card";
import Close from "@Components/Icons/Close";
import Loading from "@Components/Icons/Loading";
import InfoPopup from "@Components/InfoPopup";
import { SUCCESS } from "@Components/Toast";
import { getUnselectedCountries } from "@Helpers/CountryGroup";
import Box from "@mui/material/Box";
import React from "react";
import styles from "./index.module.scss";
export default class IncludeAllUnassigned extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
        };
    }
    onConfirm = async () => {
        if (!this.props.networkId ||
            !this.props.group ||
            this.state.isLoading) {
            return;
        }
        this.setState({ isLoading: true });
        try {
            const selectedCountries = getUnselectedCountries(this.props.countries, this.props.allGroups, this.props.group.id);
            const newGroupList = [
                ...this.props.allGroups.filter(({ id }) => id !== this.props.group?.id),
                {
                    ...this.props.group,
                    type: this.props.countryGroupType,
                    selectedCountries: [
                        ...this.props.group.selectedCountries,
                        ...selectedCountries,
                    ],
                },
            ];
            await updateSelectedCountries(this.props.networkId, newGroupList, this.props.isSync);
            this.props.close(true);
            this.props.notify({
                status: SUCCESS,
                title: "Success",
                description: "Country group include all unassigned countries successfully.",
            });
        }
        catch (error) {
            console.error("Failed to include all unassigned countries", error);
        }
        finally {
            this.setState({ isLoading: false });
        }
    };
    includeAllUnassignedPopup = (close) => {
        return (React.createElement(Card, { className: styles.includeAllUnassignedPopup },
            React.createElement(Box, { className: styles.header },
                React.createElement("h2", { className: styles.title }, "Delete group"),
                React.createElement("div", { onClick: () => close(), className: styles.closeBtn },
                    React.createElement(Close, { onClick: () => close(), color: "#585C61", size: "0.75rem", className: styles.exitButton }))),
            React.createElement(Box, { className: styles.content },
                React.createElement("p", null,
                    "Do you want to include all unassigned countries in",
                    " ",
                    React.createElement("span", null, this.props.group?.name),
                    "?")),
            React.createElement(Box, { className: styles.actions },
                React.createElement(Button, { click: () => close(), dark: true, className: styles.cancelBtn }, "CANCEL"),
                React.createElement(Button, { click: this.onConfirm, disabled: this.state.isLoading }, this.state.isLoading ? (React.createElement(Loading, { size: "1rem" })) : ("CONFIRM")))));
    };
    render() {
        return (React.createElement(InfoPopup, { trigger: this.props.open, content: this.includeAllUnassignedPopup, onClose: () => this.props.close() }));
    }
}
